import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SpendingRequestExporter  {
    _originalTypeClassName = "zERP.BO.SpendingRequestExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SpendingRequestExporter.translate = translateService;
}
this.SpendingRequestExporterKey = null;
this._key = this.SpendingRequestExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _SpendingRequestExporterKey:any;
get SpendingRequestExporterKey(): any {
    return this._SpendingRequestExporterKey;
  }
set SpendingRequestExporterKey(value: any) {
    this._SpendingRequestExporterKey = value;
    this._key = value;
  }

static GetCollectionVariables(spendingRequest: any): any{let vars = new window['Map']();
let detailsChildren = [];
detailsChildren?.add({
Name: "goodname",Description: "Όνομα αγαθού",}
);
detailsChildren?.add({
Name: "description",Description: "Περιγραφή",}
);
detailsChildren?.add({
Name: "quantity",Description: "Ποσότητα",}
);
detailsChildren?.add({
Name: "aa",Description: "Αύξων αριθμός",}
);
detailsChildren?.add({
Name: "notes",Description: "Σημειώσεις",}
);
vars.set({
Name: "DETAILS",Description: "Λεπτομέρειες",IsCollection: true,Children: detailsChildren,}
, Joove.Common.cast(spendingRequest?.Details, "System.Collections.List"));
return vars;
}
static ResolveCollectionItem(collectionName: any,varName: any,item: any): any{if (collectionName == "DETAILS") {let spendingRequestDetail = Joove.Common.cast(item, "Domain.SpendingRequestDetail");switch (varName?.toLowerCase()) {case "goodname":
{
return spendingRequestDetail?.Good?.Fullname;}
case "description":
{
return spendingRequestDetail?.Description;}
case "quantity":
{
return spendingRequestDetail?.Quantity?.toString();}
case "aa":
{
return Joove.Common.safeNumber((Joove.Common.safeNumber(spendingRequestDetail?.SpendingRequest?.Details?.indexOf(spendingRequestDetail)) + Joove.Common.safeNumber(1))) + "";}
case "notes":
{
return "";}
}}
return collectionName + "." + varName;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SpendingRequestExporterKey == null || $this.SpendingRequestExporterKey == 0;
            }


}